import React from 'react';
import SettingsNav from "../components/settingsnav";
import SettingsNavButton from '../components/settingsNavButton';
import { getIntlText } from '../js/utilities';
import { injectIntl } from "react-intl";
import { track } from 's2s-app-service';

const renderSettingButtons = (buttons) => {
  return (
    buttons.map((props, index) => {
      return (
        <SettingsNavButton
          className={props.title}
          cbClick={props.cbClick}
          description={props.description}
          key={index}
          svgType={props.svgType}
          title={props.title}
        />
      );
    })
  );
};

const Settings = ({ history, intl }) => {
  const notificationClick = () => {
    track("notification_settings", "clicked");
    history.push('/settings/notification');
  };

  const appearanceClick = () => {
    track("appearance_settings", "clicked");
    history.push('/settings/appearance');
  };

  const contactsClick = () => {
    track("contact_settings", "clicked");
    history.push('/settings/contacts');
  };

  const troubleshootingClick = () => {
    track("troubleshooting_settings", "clicked");
    history.push('/settings/troubleshooting');
  };

  const devicesClick = () => {
    track("device_settings", "clicked");
    history.push('/settings/devices');
  };

  const settingButtons = [
    {
      description: getIntlText(intl, 'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION', "Adjust how you receive updates."),
      cbClick: notificationClick,
      svgType: 'MdNotifications',
      title: getIntlText(intl, 'SETTINGS-NOTIFICATIONS-BTN-LABEL', "Notifications"),
    },
    {
      description: getIntlText(intl, 'SETTINGS-APPEARANCE-BTN-DESCRIPTION', "Change the look and feel of the application."),
      cbClick: appearanceClick,
      svgType: "AppearanceIconSVG",
      title: getIntlText(intl, 'SETTINGS-APPEARANCE-BTN-LABEL', "Appearance"),
    },
    {
      description: getIntlText(intl, 'SETTINGS-DEVICES-BTN-DESCRIPTION', "Change how your devices are configured."),
      cbClick: devicesClick,
      svgType: "MdHeadset",
      title: getIntlText(intl, 'SETTINGS-DEVICES-BTN-LABEL', "Devices"),
    },
    {
      description: getIntlText(intl, 'SETTINGS-CONTACTS-BTN-DESCRIPTION', "Import your contacts."),
      cbClick:
      contactsClick,
      svgType: "MdContacts",
      title: getIntlText(intl, 'SETTINGS-CONTACTS-BTN-LABEL', "Contacts"),
    },
    {
      description: getIntlText(intl, 'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION', "Tools to help you find out what's wrong"),
      cbClick: troubleshootingClick,
      svgType: "MdReportProblem",
      title: getIntlText(intl, 'SETTINGS-TROUBLESHOOTING-BTN-LABEL', "Troubleshooting"),
    },
  ];

  return (
    <div className="settingsRoute">
      <SettingsNav
        cbBackClick={() => {
          track("settings back", "clicked");
          history.goBack();
        }}
      >
        {renderSettingButtons(settingButtons)}
      </SettingsNav>
    </div>
  );
};

export default injectIntl(Settings);
